// @ts-nocheck

import type { RetryPolicy } from '@/core/request'
import { type BatchOptions, createFetcher } from './createFetcher'
import {
    generateGraphqlOperation,
    type GraphqlOperation,
} from './generateGraphqlOperation'
import type { ExecutionResult, LinkedType } from './types'

export type Headers =
    | HeadersInit
    | (() => HeadersInit)
    | (() => Promise<HeadersInit>)

export type BaseFetcher = (
    operation: GraphqlOperation | GraphqlOperation[],
    options?: RequestOptions,
) => Promise<ExecutionResult | ExecutionResult[]>

export type RequestOptions = {
    timeout?: number
    retries?: number
    retryPolicy?: RetryPolicy
}

export type ClientOptions = Omit<RequestInit, 'body' | 'headers'> & {
    url?: string
    batch?: BatchOptions | boolean
    fetcher: BaseFetcher
    fetch?: Function
    headers?: Headers
    timeout?: number // Таймаут по умолчанию в миллисекундах
}

export const createClient = ({
    queryRoot,
    mutationRoot,
    subscriptionRoot,
    ...options
}: ClientOptions & {
    queryRoot?: LinkedType
    mutationRoot?: LinkedType
    subscriptionRoot?: LinkedType
}) => {
    const fetcher = createFetcher(options)
    const client: {
        query?: Function
        mutation?: Function
    } = {}

    if (queryRoot) {
        client.query = (request: any, options?: RequestOptions) => {
            if (!queryRoot) throw new Error('queryRoot argument is missing')

            return fetcher(
                generateGraphqlOperation('query', queryRoot, request),
                options,
            )
        }
    }
    if (mutationRoot) {
        client.mutation = (request: any, options?: RequestOptions) => {
            if (!mutationRoot)
                throw new Error('mutationRoot argument is missing')

            return fetcher(
                generateGraphqlOperation('mutation', mutationRoot, request),
                options,
            )
        }
    }

    return client
}
